import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { ROUTES } from '@constants/routes';
import { environment } from 'src/environments/environment';

declare global {
	interface Window {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		Osano?: any;
	}
}

@Component({
	standalone: false,
	selector: 'qe-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
	public footerLogoSrc: string = 'assets/logos/embrace-grey.svg';
	public copyrightYear: number = new Date().getFullYear();
	public version: string = environment.version.split('.')?.[0];
	public isSelectedPolicy = false;
	public privacyPolicyUrl: string;
	public embracePolicyUrl: string;

	constructor(
		private readonly router: Router,
	) {
		this.privacyPolicyUrl = environment.privacyPolicyUrl;
		this.embracePolicyUrl = environment.embracePolicyUrl;
		this.router.events.subscribe((event: Event) => {
			if (event instanceof NavigationEnd) {
				this.isSelectedPolicy = event.url.includes(ROUTES.SELECT_A_POLICY);
			}
		});
	}

	public showDoNotSell(event: globalThis.Event): void {
		event.preventDefault();
		event.stopPropagation();
		window.Osano?.cm.showDoNotSell();
	}
}
